import styles from './Loader.module.scss'

type LoaderProps = {
    text?: string
    className?: string
}

export function Loader({ text = 'Loading...', className = '' }: LoaderProps) {
    return (
        <div className={`${styles.loaderWrapper} ${className}`.trim()}>
            <div className={styles.spinner} aria-label="Loading" role="status" />
            {text && <p className={styles.message}>{text}</p>}
        </div>
    )
}
